import axios, { AxiosError, AxiosRequestTransformer } from 'axios';
import * as H from 'history';
import { toast } from 'react-toastify';
import config from '../../config';
import dayjs from 'dayjs';

export const dataTransformer: AxiosRequestTransformer = (data) => {
	if (data instanceof Date) {
		const date = dayjs(data).format('YYYY-MM-DDTHH:mm:ssZ');
		return date;
	}
	if (Array.isArray(data)) {
		return data.map((val) => dataTransformer(val));
	}
	if (typeof data === 'object' && data !== null && data.constructor.name === 'Object') {
		return Object.fromEntries(
			Object.entries(data).map(([key, val]) => [key, dataTransformer(val)])
		);
	}
	return data;
};

export const axiosInstance = axios.create({
	baseURL: config.apiUrl,
	withCredentials: true,
	transformRequest: [dataTransformer].concat(axios.defaults.transformRequest!),
});

export const Interceptors = {
	setupTokenInterceptor: () => {
		axiosInstance.interceptors.request.use((config) => {
			const token = localStorage.getItem('accessToken');
			const RequestToken = localStorage.getItem('__RequestVerificationToken');
			const formToken = localStorage.getItem('__formtoken');
			const website = localStorage.getItem('__website');
			config.headers!['Authorization'] = `Bearer ${token}`;
			config.headers!['__formtoken'] = formToken!;
			config.headers!['__RequestVerificationToken'] = RequestToken!;
			config.headers!['__website'] = website!;
			return config;
		});
	},
	setupUnauthorizedInterceptor: (history: H.History) => {
		axiosInstance.interceptors.response.use(
			(response) => response,
			(error) => {
				const response = (error as AxiosError).response;
				if (response) {
					const { data, status } = response!; //We are adding the ! because we know we will have a error response here
					switch (status) {
						case 400:
							if (data.ModelState) {
								const modelStateErrors: string[] = [];
								for (const key in data.ModelState) {
									if (data.ModelState[key]) {
										modelStateErrors.push(data.ModelState[key]);
									}
								}
								throw modelStateErrors.flat();
							}
							toast.error(data.Message);
							break;
						case 401:
							if (!window.location.href.includes("login")) {
								history.push('/login');
								break;
							}

							if ((response.config.url?.includes("Account/Logout"))) {
								toast.error('Session has been logged out, you will be redirected to the login page');
								history.push('/login');
								break;
							}

							break;
						case 403:
							break;
						case 404:
							toast.error('Not found');
							break;
						case 500:

							//to distinguish between normal server errors and null reference errors caused by invalid username/password values
							if (response.config.url?.includes("UserForgotPassword")) {
								toast.error('Invalid Token or Login Credentials.');
								break;
							}

							toast.error('Server error - Please Contact BEE123');
							break;
					}
				}
				return Promise.reject(error);
			}
		);
	},
};
